import { component_tool } from '@/tool'
let { WizModal } = component_tool

//配置项
let componentName = 'satisfaction'

const columns = [
  {
    name: 'id',
    dataIndex: 'id',
    formItem: {
      type: 'hidden'
    }
  },
  {
    title: '满意度参数',
    name: 'name',
    dataIndex: 'name',
    searchItem: {},
    formItem: {
      maxLength: 10,
      rules: [{ required: true, message: '请输入满意度参数' },{
        pattern: /^[^\s]*$/,
        message: '满意度参数不可包含空格'
      }]
    },
    tableItem: {}
  },
  {
    title: '辅导模块',
    name: 'moduleType',
    dataIndex: 'moduleType',
    dict: [
      { code: 0, codeName: '销售' },
      { code: 1, codeName: '售后' }
    ],
    searchItem: {
      type: 'select'
    },
    formItem: {
      type: 'select',
      rules: [{ required: true, message: '请选择辅导模块' }]
    },
    tableItem: {
      type: 'select'
    }
  },
  {
    title: '值类型',
    name: 'valueType',
    dataIndex: 'valueType',
    dict: [
      { code: 0, codeName: '正整数' },,
      { code: 1, codeName: '百分比' },
      { code: 2, codeName: '文字' },
      { code: 3, codeName: '百分比，x/y' },
      { code: 4, codeName: '浮点数' }
    ],
    formItem: {
      type: 'select',
      rules: [{ required: true, message: '请选择值类型' }]
    },
    tableItem: {}
  },
  {
    title: '状态',
    name: 'state',
    dataIndex: 'state',
    dict: [
      { code: 0, codeName: '禁用' },
      { code: 1, codeName: '启用' }
    ],
    searchItem: {
      type: 'select'
    },
    tableItem: {
      type: 'select'
    }
  }
]

const templateConfig = {
  mainProps: {},
  content: {
    name: 'WizTableList',
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['add', 'export'],
        buttons: [
          {
            key: 'export',
            custom: true,
            params: { icon: 'export', children: '导出', type: 'export' },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'export',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return { ...filters }
              }
            }
          }
        ],
        collapse: false,
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: 'id',
        isScroll: true,
        loading: false
      },
      rowOperateSort: ['enableOrDisable'],
      rowOperateView: [
        {
          key: 'enableOrDisable',
          custom: true,
          params: { children: '启用' },
          textFormat: {
            recordKey: 'state',
            dirt: { 0: '启用', 1: '禁用' }
          },
          customOnClick: {
            key: 'action',
            params: {
              apiKey: 'enable',
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              const content = `您确定要${record['state'] === 0 ? '启用' : '禁用'}该配置吗？`
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    state: record['state'] === 1 ? 0 : 1,
                    id: record['id']
                  })
                },
                onCancel() {
                }
              })
              return null
            }
          }
        }
      ]
    }
  }
}

const apis = {
  list: {
    path: `${componentName}/list`,
    payload: {
      key: `${componentName}@list`,
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  enable: {
    path: `${componentName}/enable`,
    payload: {
      key: `${componentName}@enable`,
      apiParams: {}
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
}

export { reduxTemplateCofig, templateConfig }
